import { DatePicker } from "@material-ui/pickers";
import { format, parseISO } from "date-fns";
import React from "react";
import {
  NumberInput,
  Record,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import resourceNames from "../../../../common/data/resourceNames";
import { FormDivider } from "../../../common/form/FormDivider";
import { GenericDateOrTimePicker } from "../../../common/form/GenericDateOrTimePicker";
import "./VehicleMaintenanceForm.css";

interface Props {
  vehicleId?: number;
  record?: Record;
}

export const NextMaintenanceForm = ({ vehicleId, ...props }: Props) => {
  return (
    <>
      <FormDivider />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="nextMaintenanceDate"
        label="resources.assets-vehicle-maintenance.labels.nextMaintenanceDate"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        {...props}
      />
      <NumberInput
        source="nextMaintenanceOdometer"
        {...props}
        label="resources.assets-vehicle-maintenance.labels.nextMaintenanceOdometer"
      />
      <TextInput
        multiline
        source="nextMaintenanceNotes"
        {...props}
        label="resources.assets-vehicle-maintenance.labels.nextMaintenanceNotes"
      />
      <ReferenceInput
        allowEmpty
        emptyText="(None)"
        source="previousOilChangeId"
        label="resources.assets-vehicle-maintenance.labels.previousOilChangeId"
        reference={resourceNames.ASSETS_VEHICLE_MAINTENANCE}
        filter={
          props.record?.id
            ? {
                vehicleId,
                nextMaintenanceDone: false,
                _not: [{ field: "id", value: props.record?.id }],
              }
            : { vehicleId, nextMaintenanceDone: false }
        }
        {...props}
      >
        <SelectInput
          allowEmpty
          emptyText="(None)"
          optionText={(record) => (
            <div className="previous-oil-change-choice">
              <div>{format(parseISO(record.date), "MMM do, yyyy")}</div>
              <div>{record.notes ?? "-"}</div>
              <div>at {record.vehicleOdometer} mileage</div>
            </div>
          )}
        />
      </ReferenceInput>
    </>
  );
};
